<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">

            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-medkit"></i> Seat Availability Chennai Floor</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm"  routerLink="/dashboard"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>

           

             <div class="row row-replace m-t-30">
                 <div class="col-12">
                     <div style="background-image:url('./assets/img/back/chennai.png');width:600px;height:1100px;border:1px solid black;margin:0 auto;" class="zoom">
                    
                        <!-- <button class="btn btn-sm btn-success setPo" *ngFor="let x of numb" [ngStyle]="{'margin':x.xy}">{{x.n}}</button> -->
                        
                        <button class="btn btn-sm btn-success setPo" style="margin:39px 0 0 88px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:61px 0 0 56px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:61px 0 0 122px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:87px 0 0 56px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:87px 0 0 122px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:111px 0 0 56px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:111px 0 0 122px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:136px 0 0 56px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:136px 0 0 122px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:38px 0 0 248px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:38px 0 0 322px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:65px 0 0 238px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:65px 0 0 339px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:120px 0 0 238px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:120px 0 0 339px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:150px 0 0 248px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:150px 0 0 322px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:194px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:194px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:194px 0 0 343px">2</button>
                        
                        <button class="btn btn-sm btn-success setPo" style="margin:236px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:236px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:236px 0 0 343px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:291px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:291px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:291px 0 0 343px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:332px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:332px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:332px 0 0 343px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:387px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:387px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:387px 0 0 343px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:428px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:428px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:428px 0 0 343px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:482px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:482px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:482px 0 0 343px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:523px 0 0 237px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:523px 0 0 274px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:523px 0 0 343px">2</button>

                        <button class="btn btn-sm btn-success setPo" style="margin:339px 0 0 45px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:339px 0 0 145px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:365px 0 0 47px">2</button>
                        <button class="btn btn-sm btn-success setPo" style="margin:365px 0 0 145px">2</button>






                    </div>
                 </div>
             </div>

             
        </div>
    </div>
</div>           

